import Record from "./base"

export class Stat extends Record {}



// WEBPACK FOOTER //
// ./src/store/serializers/stat.js